import { observer } from "mobx-react-lite"

import { cn } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools"
import { DisplayTokens } from "@/domains/tokens/components/display-tokens"
import useResponsive from "@/hooks/use-responsive"

export const PoolInfoColumn = observer(({ pool, chainSlug }: { pool: ILiquidityPool; chainSlug: string }) => {
  const { isMobile } = useResponsive()

  if (isMobile) {
    return (
      <div className={cn("flex flex-row items-center gap-4 ")}>
        <div className="text-left">
          <div className="whitespace-nowrap text-t100">{pool.displayName}</div>
          <div className="mb-1 flex flex-row items-center gap-1 text-xs text-t300">{pool.displayType}</div>
          <div className="flex flex-row items-center gap-1">
            <DisplayTokens tokens={pool.tokens} tokenSize={14} gap={2} overlap={0} />
            <div className="text-[10px] leading-none text-t200">{pool.displayFee}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={cn("flex flex-row items-center ")}>
      <DisplayTokens tokens={pool.tokens} tokenSize={38} />
      <div className="ml-[10px] text-left">
        <div className="whitespace-nowrap text-t100">{pool.displayName}</div>
        <div className="mb-1 flex flex-row items-center gap-1 text-xs text-t300">{pool.displayType}</div>
        <div className="text-[10px] leading-none text-t300">{pool.displayFee}</div>
      </div>
    </div>
  )
})
